module.exports = "/images/de.svg";